// Created by PeakXin on 2025/12/25.
import request from '@/utils/request'

export function getAgentInfo() {
  return request({
    url: '/v1/3d-vision/agent/detail',
    method: 'get'
  })
}
